'use strict';

import $ from 'jquery';
import mediator from '../../js/mediator';
import config from '../../js/config';


export default class JumpToAjaxContent {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.initialize();
  }

  initialize() {
    this.isVisible = false;
    this.$links = this.$el.find('a');
    this.scrollToOffset = this.$el.data('scrollToOffset');
    this.$el.on('click', 'a', this.onLinkClick.bind(this));
    mediator.on(config.events.ui.ajaxContentLoaded, this.onAjaxContentLoaded, this);
  }

  /**
   * Triggered when AJAX has injected HTML in to a container.
   *
   * @param {jQuery} $container - The jQuery object of the container
   */
  onAjaxContentLoaded($container) {
    if (!$container || !$container.length) { return; }

    let frag = '#' + $container.attr('id');
    let $link = this.$links.filter((n, el) => el.getAttribute('href') === frag);

    // If we have a matching link and the element is not empty
    if ($link.length && this.containerHasContent($container)) {
      this.showLink($link);
    }
  }

  containerHasContent($container) {
    let returnResult = false;
    if ($container) {
      if ($container.html) {
        if ($container.html()) {
          returnResult = !!$container.html().trim().length;
        }
      }
    }
    return returnResult;
  }

  onLinkClick(e) {
    e.preventDefault();

    mediator.trigger(config.events.scrollTo, {
      selector: $(e.currentTarget).attr('href'),
      offset: this.scrollToOffset
    });
  }

  /**
   * Show a specific jump to link.
   *
   * @param {jQuery} $link - The anchor element to show
   */
  showLink($link) {
    // Show the jump links if they were previously hidden
    if (!this.isVisible) {
      this.isVisible = true;
      this.$el.addClass(config.classes.isVisible);
    }

    // Show the links parent li
    $link.parent().addClass(config.classes.isVisible);
  }
}

export function createJumpToAjaxContent($parent) {
  $parent.find('.JumpToAjaxContent').each((n, el) => new JumpToAjaxContent(el));
}



// WEBPACK FOOTER //
// ./assets/components/JumpToAjaxContent/JumpToAjaxContent.js